// import '@tencent/particle-ui/dist/pui.css';
import '@tencent/cms-design-component/lib/dist/style/main.css';
import '@tencent/intl-design-ui/lib/scss/intl-ui.min.css';
// import { getEidList } from '../apis/cmsApi';
import { pageRenderer } from '../components/renderer';
export var __N_SSP = true;
export default function Renderer(props) {
    return pageRenderer(props);
};
